/**
 * Create an encoded csv string from array data
 * @param header
 * @param data
 * @returns { string }
 */
export const useCreateCsvString = (header, data) => {
    const csvFriendlyString = [ header, ...data ].map(r => Array.isArray(r) ? r.map(val => `"${val ?? ''}"`).join(",") : `"${r ?? ''}"`).join("\n");
    return `data:text/csv;charset=utf-8,${encodeURIComponent(csvFriendlyString)}`;
}